module.exports = __webpack_public_path__ + "img/scucess.452a957c.png";